import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBrj8njQ3m2lfGDnGRxYqI0cl7t6bWJYZ0",
  authDomain: "artshat-330b1.firebaseapp.com",
  projectId: "artshat-330b1",
  storageBucket: "artshat-330b1.firebasestorage.app",
  messagingSenderId: "902772611687",
  appId: "1:902772611687:web:ed06d242e04a07110792c2",
  measurementId: "G-1C0YCF1R0J"
};


const app = initializeApp(firebaseConfig);

// Միացնում ենք Local Cache (Offline Persistence)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache()
});
export const auth = getAuth(app);
export const storage = getStorage(app);
